(ns frontend.ui.component.radio-group.view
  (:require
   [frontend.ui.component.icon.view :refer [icon]]
   [frontend.ui.component.label.view :refer [label]]
   [frontend.ui.component.radio-group.style :as style]
   [herb.core :refer [<class]]))

(defn radio-group
  "Group of radio values.

  `name` is compulsory: it allows grouping these values."
  [{:keys [name on-change checked disabled?] :as props} values]
  (into [:<>]
        (for [[id value] values]
          (let [checked? (= id checked)]
            [label
             ;; Hidden with CSS because a HTML radio input cannot be styled
             [:input
              {:type      "radio"
               :class     (<class style/hidden-input)
               :name      name
               :disabled  disabled?
               :checked   checked?
               :on-change #(on-change id)}]
             [icon
              {:class   (<class style/icon
                                (assoc props :checked? checked?))
               :variant (if checked? :solid :light)}
              (if checked? :dot-circle :circle)]
             value]))))
